export const GET_USER_PRODUCT_DETAIL_FIELDS = "GET_USER_PRODUCT_DETAIL_FIELDS"
export const GET_USER_PRODUCT_DETAIL = "GET_USER_PRODUCT_DETAIL"
export const GET_PRODUCTS_USER = "GET_PRODUCTS_USER"
